module.exports = __webpack_public_path__ + "static/media/mira_search_prototype.be91df1f.png";